import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface StatCardProps {
  label: string;
  value: number | string;
  sub?: string;
  icon: React.ElementType;
  iconClass?: string;
  bgClass?: string;
}

export function StatCard({ label, value, sub, icon: Icon, iconClass = "text-muted-foreground", bgClass = "bg-muted" }: StatCardProps) {
  return (
    <Card size="sm">
      <CardContent className="flex items-center justify-between gap-4 py-1">
        <div>
          <p className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">{label}</p>
          <p className="mt-1 text-3xl font-bold tabular-nums">{value}</p>
          {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
        </div>
        <div className={`flex size-10 shrink-0 items-center justify-center ${bgClass}`}>
          <Icon className={`size-5 ${iconClass}`} />
        </div>
      </CardContent>
    </Card>
  );
}

export function StatCardSkeleton() {
  return (
    <Card size="sm">
      <CardContent className="flex items-center justify-between gap-4 py-1">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-8 w-12" />
          <Skeleton className="h-3 w-20" />
        </div>
        <Skeleton className="size-10 shrink-0" />
      </CardContent>
    </Card>
  );
}
